import { Component, OnInit, HostListener } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../core/services/shared.service';

@Component({
  selector: 'app-default-layout',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, SideNavComponent, RouterOutlet, CommonModule],
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.scss',
})
export class DefaultLayoutComponent implements OnInit {
  sideNavVisible: boolean = true;

  constructor(private router: Router, private sharedService: SharedService) {
    this.router.navigate(['company-information']);
  }

  ngOnInit() {
    this.sharedService.sideNavVisible$.subscribe((visible) => {
      this.sideNavVisible = visible;
    });
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth > 992 && !this.sideNavVisible) {
      this.sharedService.openSideNav();
    }
  }

  closeSideNavIfSmallScreen() {
    const isSmallScreen = window.innerWidth <= 992;
    if (isSmallScreen && this.sideNavVisible) {
      this.sharedService.closeSideNav();
    }
  }
}
